import { connectOrderItemProductLabel } from './connectOrderItemProductLabel';
import { OrderItemProductLabel as OrderItemProductLabelPure } from './OrderItemProductLabel';

export const OrderItemProductLabel = connectOrderItemProductLabel(OrderItemProductLabelPure);
